import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { initSentry } from '../../index'
import { MAKE_OWNER_ASYNC } from '../Settings/Users/constants'

import {
  fetchAppDataError,
  fetchAppDataSuccess,
  refetchOwnerStatusError,
  refetchOwnerStatusSuccess,
} from './actions'
import { FETCH_APP_DATA_ASYNC, REFETCH_APP_DATA_ACTIONS } from './constants'

const fetchAppDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(FETCH_APP_DATA_ASYNC.INITIATE, ...REFETCH_APP_DATA_ACTIONS).mergeMap(() =>
    api.accounts
      .getStatus()
      .map((response) => {
        initSentry(response.environment)
        return fetchAppDataSuccess(response)
      })
      .catch((error) => Observable.of(epicsErrorHandler(fetchAppDataError, error, [])))
      .takeUntil(action$.ofType(FETCH_APP_DATA_ASYNC.CANCEL))
  )

const refetchOwnerStatusEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(MAKE_OWNER_ASYNC.SUCCESS).mergeMap(() =>
    api.accounts
      .getOwnerStatus()
      .map((response) => refetchOwnerStatusSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(refetchOwnerStatusError, error)))
      .takeUntil(action$.ofType(MAKE_OWNER_ASYNC.CANCEL))
  )

export default combineEpics(fetchAppDataEpic, refetchOwnerStatusEpic)
